import { call, put, select, takeLatest } from 'redux-saga/effects';
import { ActionType, getType } from 'typesafe-actions';
import { IPublicRestaurant, IRestaurantAvailableTimes } from '@localina/core';
import { IApplicationStore, ILocalinaWidgetApi, IRestaurantPublicMenu, IShiftOverview } from '../../interfaces';
import * as actions from './restaurant-actions';

function* fetchConfiguration(
    api: ILocalinaWidgetApi,
    action: ActionType<typeof actions.restaurantConfigurationRequested>,
) {
    const { restaurantId } = action.payload;

    try {
        const configuration: IPublicRestaurant = yield call([api, api.getRestaurantConfiguration], restaurantId);

        yield put(actions.restaurantConfigurationReceived(configuration));
    } catch (e) {
        yield put(actions.restaurantConfigurationFailed(e));
    }
}

function* fetchRestaurantMenu(api: ILocalinaWidgetApi, action: ActionType<typeof actions.restaurantMenuRequested>) {
    const { restaurantId } = action.payload;

    try {
        const menu: IRestaurantPublicMenu = yield call([api, api.getRestaurantMenu], restaurantId);

        yield put(actions.restaurantMenuReceived(menu));
    } catch (e) {
        yield put(actions.restaurantMenuFailed(e));
    }
}

function* fetchAvailableTimes(
    api: ILocalinaWidgetApi,
    action: ActionType<typeof actions.restaurantAvailableTimesRequested>,
) {
    const { restaurantId, data } = action.payload;
    const { participants, reservationDateTime, areaId, shiftId } = data;

    try {
        const availableTimes: IRestaurantAvailableTimes = yield call(
            [api, api.getAvailableAreaTimes],
            restaurantId,
            participants,
            reservationDateTime,
            shiftId,
            areaId,
        );

        yield put(actions.restaurantAvailableTimesReceived(availableTimes));
    } catch (e) {
        yield put(actions.restaurantAvailableTimesFailed(e));
    }
}

function* fetchShifts(api: ILocalinaWidgetApi, action: ActionType<typeof actions.shiftsRequested>) {
    const restaurantId: string = yield select((store: IApplicationStore) => store.restaurant.configuration?.id || '');
    try {
        const shifts: IShiftOverview[] = yield call(
            [api, api.getShifts],
            restaurantId,
            action.payload.date,
            action.payload.participants,
        );
        yield put(actions.shiftsReceived(shifts));
    } catch (e) {
        yield put(actions.shiftsError(e));
    }
}

export default function* restaurantSaga(api: ILocalinaWidgetApi) {
    yield takeLatest(getType(actions.restaurantConfigurationRequested), fetchConfiguration, api);
    yield takeLatest(getType(actions.restaurantMenuRequested), fetchRestaurantMenu, api);
    yield takeLatest(getType(actions.restaurantAvailableTimesRequested), fetchAvailableTimes, api);
    yield takeLatest(getType(actions.shiftsRequested), fetchShifts, api);
}
